import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/src/lib/webapp-common.dto';
import { ISSUES_BASE } from '../consts';
import {
  EndpointsSettingsResponse,
  GetEndpointsSettingsQuery,
} from '@hud/portal-dtos/issues.dtos';

export const HEADS_UP_SETTINGS_ID = 'heads-up-settings';

export default function useHeadsUpSettingsQuery(
  params: GetEndpointsSettingsQuery,
) {
  const { client, isReady } = useClient();

  return useQuery<EndpointsSettingsResponse, AxiosError<ErrorResponse>>({
    queryKey: [HEADS_UP_SETTINGS_ID, params],

    queryFn: async () => {
      const response = await client.get<EndpointsSettingsResponse>(
        `${ISSUES_BASE}/endpoints-settings`,
        {
          params,
        },
      );
      return EndpointsSettingsResponse.parse(response.data);
    },

    enabled: isReady && !!params.environmentName,

    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
